export const ASSESSMENT_ASSIGN_STATUS = {
  assigned: "assigned",
  pending: "pending",
  accepted: "accepted",
  declined: "declined",
  rejected: "rejected",
  shortlisted: "shortlisted",
  completed: "completed",
};

export const questionNumCount = 15;
